import styled, { css } from "styled-components";

import Spring from "../../components/Spring";
import { isMobile } from "../../../common/parameters";

export const BackBtn = styled.div`
    height: 61px;
    ${p =>
        p.theme.sm.max(css`
            height: 0;
        `)};
`;

export const Editor = styled(Spring)`
    min-height: calc(100vh - 50px);
    background-color: ${p => p.theme.c.snow};
    padding-top: 20px !important;
    ${isMobile &&
    css`
        min-height: calc(100vh - 220px);
    `}
    box-sizing: border-box;
`;

export const Wrapper = styled.div`
    position: relative;
`;

export const Pagination = styled.div`
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    align-items: center;
    ${p =>
        p.theme.xs(css`
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: ${p => p.theme.c.snow};
            z-index: 10;
            top: auto;
            justify-content: center;
            padding: 6px;
            padding-right: 44px;
            ${p.theme.withNotch(css`
                padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 6px);
            `)}
        `)}
`;

export const TutorialButton = styled.div`
    margin-left: 8px;
    display: inline-block;
`;

export const Gap = styled.div`
    ${p =>
        p.theme.sm.max(css`
            margin-top: 64px;
        `)}
`;
